import { useState } from 'react'
import { BsBank2, BsFillWalletFill } from 'react-icons/bs'
import { FaRegMoneyBillAlt } from 'react-icons/fa'
import { GiMoneyStack } from 'react-icons/gi'
import { HiDotsVertical } from 'react-icons/hi'
import { useDispatch } from 'react-redux'
import { IBank } from 'safe'
import FloatingMenu from '../../components/Display/FloatingMenu'
import Modal from '../../components/Display/Modal'
import ModalConfirm from '../../components/Display/ModalConfirm'
import ModalViewWithTabs from '../../components/Display/ModalViewWithTabs'
import { DataTabView } from '../../components/Display/ViewWithTabs'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { deleteAccount, setAccountVisible } from '../../redux/actions/accounts'
import { getAccountType, getBankAccountType, getDenomination } from '../../utils/utils'
import EditAccountForm from './EditAccountForm'

const AccountCard: React.FC<AccountCardProps> = ({
  account,
  fromSafeBox = false,
  onPressCardProp = () => null,
  banks = [],
  onEdit,
  // setFormAccountModal,
  // setEditingAccount,
}) => {
  const [modalDescription, setModalDescription] = useState<boolean>(false)
  const [visibleMenu, setVisibleMenu] = useState<boolean>(false)
  const [displayConfirm, setDisplayConfirm] = useState<boolean>(false)
  const [editModal, setEditModal] = useState<boolean>(false)
  const [dataWithTabs, setDataWithTabs] = useState<DataTabView[]>([])

  const { addAlert } = useSnackBars()

  const onPressCard = () => {
    const account_details = { title: '', data: '' }
    const dataToShow: DataTabView[] = []
    account_details.title = 'Cuenta'
    account_details.data += `Tipo de Cuenta: ${getAccountType(
      account.accountType
    )} \n`
    // account_details.data += `Moneda: ${account.currency.name} \n`
    // account_details.data += `Balance: ${account.balance} ${account.currency.code} \n`
    // account_details.data += `Visible al Público: ${account.accountVisible ? 'SÍ' : 'NO'
    //   } \n`

    if (account.accountType === 'CASH') {
      account_details.data += `Descripción: ${account.description} \n`
      dataToShow.push(account_details)
    }

    if (account.accountType === 'BANK_ACCOUNT') {
      account_details.data += `Titular: ${account.owner} \n`
      account_details.data += `Documento: ${account?.documentType}-${account?.document} \n`
      account_details.data += `Banco: ${banks.find((b) => String(b.id) === account?.idBank)?.name
        || 'Sin nombre'
        } \n`
      account_details.data += `Tipo de Cuenta: ${getBankAccountType(
        account.bankAccountType
      )} \n`
      account_details.data += `Número de Cuenta: ${account.bankAccountNumber}\n`

      account_details.data += `Balance: ${account.balance}\n`

      account_details.data += `Moneda: ${getDenomination(account.idCurrency)}`

 
      const payment_methods = { title: '', data: '' }
      payment_methods.title = 'Métodos de Pago'
      // if (account.bankAccountNumber) {
      //   payment_methods.data += `-\tTransferencia: \n`
      //   payment_methods.data += `\tNúmero de Cuenta: ${account.bankAccountNumber}\n\n`
      // }

      if (account.mobilePaymentPhone) {
        payment_methods.data += `-\tPago Móvil: \n`
        payment_methods.data += `\tTeléfono: ${account.mobilePaymentPhone}\n\n`
      }

      if (account.cardSwiperNumber) {
        payment_methods.data += `-\tPunto de Venta: \n`
        payment_methods.data += `\tCódigo del Punto: ${account.cardSwiperNumber}\n\n`
      }
      dataToShow.push(account_details)
      payment_methods.data.length && dataToShow.push(payment_methods)
      setDataWithTabs(dataToShow)
    }
    
    if (account.accountType === 'OTHER') {
      account_details.data += `Titular: ${account.owner} \n`
      account_details.data += `Número de cuenta: ${account.accountNumber} \n`
      account_details.data += `Descripción: ${account.description} \n`

      dataToShow.push(account_details)
      setDataWithTabs(dataToShow)
    }

    setDataWithTabs(dataToShow)
  }

  const dispatch = useDispatch()

  const toggle = (): void => {
    setVisibleMenu((state) => !state)
  }

  const setVisible = async (wantedState: boolean) => {
    try {
      addAlert({
        message: 'Actualizando cuenta...',
        status: 'loading',
      })
      await dispatch(setAccountVisible(account.id, wantedState))
      addAlert({
        message: 'Visibilidad actualizada con éxito',
        status: 'success',
      })
    } catch (error: any) {
      addAlert({
        message:
          error.response.data.message || 'Error al modificar disponibilidad en cuenta',
        status: 'error',
      })
    } finally {
      toggle()
    }
  }

  const deleteAccountFlow = async () => {
    try {
      addAlert({
        message: 'Eliminando cuenta...',
        status: 'loading',
      })
      await dispatch(deleteAccount(account.id))
      addAlert({
        message: 'Cuenta eliminada con éxito',
        status: 'success',
      })
    } catch (error: any) {
      console.log("RESPONSE", error?.response?.data?.message)
      if (error?.response?.data?.message === 'Account have associated accounting records') {
        addAlert({
          message: 'No se puede eliminar esta cuenta porque tiene registros contables asociados',
          status: 'error',
        })
      } else {
        addAlert({
          message:
            error?.response?.data?.message || 'Error al eliminar cuenta bancaria',
          status: 'error',
        })
      }
    } finally {
      setDisplayConfirm(false)
    }
  }

  return (
    <>
      <ModalViewWithTabs
        display={modalDescription}
        onClose={() => {
          setModalDescription(false)
        }}
        dataWithTabs={dataWithTabs}
      />

      <div className="2xl:w-96 w-80 shadow-lg rounded-lg p-4 mb-5 mr-5 text-xl flex justify-between relative dark:bg-black m-auto">
        <div
          className="w-80 cursor-pointer"
          onClick={() => onPressCardProp()}
          // style={{ opacity: account.accountVisible ? '1' : '0.4' }}
        >
          <div className="flex mb-3">
            <div className="mr-4 dark:text-white text-dark">
              {account.accountType === 'CASH' && <GiMoneyStack size="1.2rem" />}
              {account.accountType === 'BANK_ACCOUNT' && (
                <BsBank2 size="1.2rem" />
              )}
              {account.accountType === 'OTHER' && (
                <BsFillWalletFill size="1.2rem" />
              )}
            </div>
            <div className="truncate text-primary-600 font-medium text-sm dark:text-white">
              {(() => {
                const type = account.accountType
                if (type === 'CASH') return 'EFECTIVO'
                if (type === 'BANK_ACCOUNT') return banks.find((b) => String(b.id) === account.bank?.id)?.name || 'Banco Nacional'
                if (type === 'OTHER') return '' || 'INTERNACIONAL / OTROS'
              })()
              }
            </div>
          </div>
          <div className="h-8 flex items-center">
            <div className="flex items-center truncate text-primary-600 font-medium">
              <div className="mr-4">
                <FaRegMoneyBillAlt size="0.9rem" className="dark:text-white text-dark" />
              </div>
              <div className="truncate text-sm max-h-10 dark:text-white">
                {/* {account.currency.code === 'VES' ? 'BOLÍVAR' : account.currency.name} */}
                {account.description || account.walletDescription || 'Sin descripción'}
              </div>
            </div>
          </div>

          {/* <div className="h-8 flex justify-between">
            <div className="flex items-center truncate text-primary-600 font-medium">
              <div
                className={`truncate text-sm max-h-10 ${Number(account.balance) < 0
                  ? 'text-danger'
                  : 'text-primary-500'
                  }`}
                style={{ fontSize: '12px' }}
              >
                {Number(account.balance).toFixed(2)} {account.idCurrency === '2' ? 'Bolívares' : 'Dolares'}
              </div>
            </div>

            <div className="flex items-center truncate text-primary-600 font-medium">
              <div
                className="truncate text-sm max-h-10 dark:text-white"
                style={{ fontSize: '12px' }}
              >
                {account.accountVisible ? 'HABILITADA' : 'DESHABILITADA'}
              </div>
            </div>
          </div> */}
        </div>

        {!fromSafeBox && (
          <FloatingMenu
            onClose={() => {
              setVisibleMenu(false)
            }}
            visible={visibleMenu}
            options={{
              onCustomButtons: [
                {
                  title: "Ver",
                  action: () => {
                    onPressCard()
                    setModalDescription(true)
                  },
                  display: true
                },
                // {
                //   title: account.accountVisible ? "Deshabilitar" : "Habilitar",
                //   action: () => setVisible(!account.accountVisible),
                //   display: true
                // },
                // {
                //   title: "Reajustar Saldo",
                //   action: () => {
                //     toggle()
                //     onEdit && onEdit()
                //   },
                //   display: true
                // },
                {
                  title: "Editar Cuenta",
                  action: () => setEditModal(true),
                  display: true
                },
                {
                  title: "Eliminar",
                  action: () => setDisplayConfirm(true),
                  display: true
                }
              ]
            }
            }
          >
            <HiDotsVertical
              className="cursor-pointer text-gray-400"
              onClick={toggle}
            />
          </FloatingMenu>
        )}
      </div>

      <ModalConfirm
        title={'¿Está seguro que desea eliminar esta cuenta?'}
        displayConfirmModal={displayConfirm}
        onConfirm={() => deleteAccountFlow()}
        onCancel={() => setDisplayConfirm(false)}
      ></ModalConfirm>

      {banks.length &&

        <Modal
          display={editModal}
          onClose={() => setEditModal(false)}
        >
          <EditAccountForm
            banks={banks}
            editingAccount={account}
            onCancel={() => {

              setEditModal(false)
            }}
          />
        </Modal>
      }

    </>
  )
}

interface AccountCardProps {
  account: any
  fromSafeBox?: boolean
  onPressCardProp?: Function
  onEdit?: Function
  banks?: IBank[]
  // setEditingAccount: Function
  // setFormAccountModal: Function
}

export default AccountCard
